import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

import { Breadcrumbs } from '../Breadcrumbs';
import type {
  BreadcrumbType,
} from '../Breadcrumbs';
import { PageTitle } from '../PageTitle';

const StyledWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  paddingBottom: indents.INDENT_8,
}));

const StyledBreadcrumbsWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginBottom: indents.INDENT_7,
}));

export const StyledHeaderBlockWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginBottom: indents.INDENT_6,
}));

export type EditLayoutProps = {
  /**
   * Массив объектов хлебных крошек
   */
  breadcrumbs: BreadcrumbType[];
  /**
   * Заголовок страницы
   */
  title: ReactNode;
  /**
   * Блок, выводящийся между заголовком страницы и содержимым
   */
  headerBlock?: ReactNode;
  /**
   * Содержимое страницы
   */
  children?: ReactNode;
};

export function EditLayout({
  breadcrumbs,
  title,
  headerBlock = undefined,
  children = undefined,
}: EditLayoutProps): ReactElement {
  return (
    <StyledWrapper>
      <StyledBreadcrumbsWrapper>
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
        />
      </StyledBreadcrumbsWrapper>

      <PageTitle
        pageType="form"
      >
        {title}
      </PageTitle>

      {
        headerBlock && (
          <StyledHeaderBlockWrapper>
            {headerBlock}
          </StyledHeaderBlockWrapper>
        )
      }

      {children}
    </StyledWrapper>
  );
}
